import Vue from 'vue'
import store from '@/store'

Vue.directive('sensitive', {
  bind (el) {
    el.removeAttribute('name')
  }
})

Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        if (binding.expression) {
          vnode.context[binding.expression](event)
        }
      }
    }
    if (document && document.body) {
      document.body.addEventListener('click', el.clickOutsideEvent)
    }
  },
  unbind (el) {
    if (document && document.body) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  }
})

Vue.directive('hide-if-not-authorized', {
  bind (el, binding) {
    if (Array.isArray(binding.value)) {
      let unauthorized = true
      binding.value.forEach(routePermission => {
        if (store.state.auth.userPermissions.find(p => p.name === routePermission)) {
          unauthorized = false
        }
      })
      if (!unauthorized) { return }
    }
    if (store.state.auth.userPermissions.find(p => p.name === binding.value)) { return }
    el.style.display = 'none'
  }
})
